import { useRef, useEffect } from 'react'
import * as d3 from 'd3'
import PropTypes from 'prop-types'

import style from '@aytm/app/stats/page/question-views/sh/components/shelf/styles/ShelfChart.module.scss'

import { renderContours } from '@aytm/app/stats/page/question-views/sh/components/shelf/lib/d3HeatmapRenderer'
import { renderDots } from '@aytm/app/stats/page/question-views/sh/components/shelf/lib/d3DotsRenderer'

const Heatmap = ({ id, width, height, mode, heatmap, scale = 1 }) => {
  const contentRef = useRef(null)
  // Per-instance gradient id avoids ID collisions if multiple shelf charts are on
  // the same page; legacy Coffee used a single global `#linear` from the heatmap
  // question template, which leaks if shelf is rendered without that template.
  const gradientId = `shelf-linear-${id}`

  useEffect(() => {
    if (!contentRef.current) return

    const content = d3.select(contentRef.current)

    if (mode === 'heatmap' || mode === 'pheatmap') {
      if (heatmap?.contours && heatmap?.levels) {
        renderContours(content, { heatmap, mode, width, height })
      }
    } else {
      renderDots(contentRef.current, {
        points: heatmap?.points || [],
        id,
        scale,
        gradientId
      })
    }

    return () => {
      content.selectAll('*').remove()
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, width, height, mode, heatmap?.contours, heatmap?.levels, heatmap?.points, scale])

  return (
    <svg id={`svg-heatmap${id}`} className={style['svg-heatmap']} width={width + 50} height={height}>
      <defs>
        <radialGradient id={gradientId}>
          <stop offset="6" stopColor="#ffffff" />
          <stop offset="7" stopColor="#DCDCDC" />
        </radialGradient>
      </defs>
      <g ref={contentRef} />
    </svg>
  )
}

Heatmap.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  mode: PropTypes.oneOf(['heatmap', 'pheatmap', 'clicks']).isRequired,
  heatmap: PropTypes.shape({
    levels: PropTypes.array,
    contours: PropTypes.array,
    points: PropTypes.array
  }),
  scale: PropTypes.number
}

Heatmap.displayName = 'Heatmap'

export default Heatmap
